export default __webpack_public_path__ + "static/tablet_frame-c4535b7d89f2fa9cdae8fb8377c8b29a.png";